import {
    combineSlices,
    configureStore,
} from '@reduxjs/toolkit'

import { talkJsSlice } from '../../../store/talkJsSlice'
import { userSlice, type UserState } from '../../../store/userSlice'
import { airportsSlice, type AirportsState } from './airportsSlice'

type StoreInitState = {
    user: UserState;
    airports: AirportsState;
}

const rootReducer = combineSlices(userSlice, airportsSlice, talkJsSlice)

export const getStore = (initState: StoreInitState) => configureStore({
    reducer: rootReducer,
    preloadedState: initState,
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof getStore>
export type AppDispatch = AppStore['dispatch']
